// 引入配置文件
const defaultSettings = require('@/settings.js')

// 接口地址
const url = defaultSettings.hostName;

const api = {
	// 用户登录
	login: {
		url: url + 'login',
		description: '用户登陆',
		type: 'POST'
	},
	// 菜单列表
	menuList: {
		url: url + 'sys-menu-button/tree',
		description: '菜单列表',
		type: 'POST'
	},
	// 用户列表
	userList: {
		url: url + 'sys-user/vlistPage',
		description: '用户列表',
		type: 'POST'
	},
	// 用户新增
	userAdd: {
		url: url + 'sys-user/add',
		description: '用户新增',
		type: 'POST'
	},
	// 用户修改
	userUpdate: {
		url: url + 'sys-user/update',
		description: '用户修改',
		type: 'POST'
	},
	// 用户删除
	userDelete: {
		url: url + 'sys-user/delete',
		description: '用户删除',
		type: 'POST'
	},
	// 用户查看
	userInfo: {
		url: url + 'sys-user/info',
		description: '用户查看',
		type: 'POST'
	},
	// 用户重置密码
	userReset: {
		url: url + 'sys-user/reset',
		description: '用户重置密码',
		type: 'POST'
	},
	// 树结构
	tree: {
		url: url + 'sys-company-group/tree',
		description: '树结构',
		type: 'POST'
	},
	// 用户角色
	roleList: {
		url: url + 'sys-role/list',
		description: '用户角色',
		type: 'POST'
	},
	// 用户角色
	roleListPage: {
		url: url + 'sys-role/listPage',
		description: '用户角色',
		type: 'POST'
	},
	// 用户状态
	updateStatus: {
		url: url + 'sys-user/updateStatus',
		description: '用户状态',
		type: 'POST'
	},
	// 用户导出
	userExport: {
		url: url + 'download/sys-user/export',
		description: '用户状态',
		type: 'POST'
	},
	// sku列表
	skuList: {
		url: url + 'sku-info/list',
		description: 'sku列表',
		type: 'POST'
	},
	// 新增sku
	skuAdd: {
		url: url + 'sku-info/add',
		description: '新增sku',
		type: 'POST'
	},
	// 修改sku
	skuUpdate: {
		url: url + 'sku-info/update',
		description: '修改sku',
		type: 'POST'
	},
	// 删除sku
	skuDelete: {
		url: url + 'sku-info/delete',
		description: '删除sku',
		type: 'POST'
	},
	// sku状态
	skuUpdateStatus: {
		url: url + 'sku-info/updateStatus',
		description: 'sku状态',
		type: 'POST'
	},
	// 菜单树结构
	menuTree: {
		url: url + 'sys-menu-button/listTree',
		description: '树结构',
		type: 'POST'
	},
	// 新增权限
	addRole: {
		url: url + 'sys-role/add',
		description: '新增权限',
		type: 'POST'
	},
	// 更新角色
	updateRole: {
		url: url + 'sys-role/update',
		description: '更新角色',
		type: 'POST'
	},
	// 获取角色信息
	getRoleInfo: {
		url: url + 'sys-role/info',
		description: '获取角色信息',
		type: 'POST'
	},
	// 删除角色
	deleteRole: {
		url: url + 'sys-role/delete',
		description: '删除角色',
		type: 'POST'
	},
	// 获取价格方案管理
	getPriceList: {
		url: url + 'price-main/list',
		description: '获取价格方案管理',
		type: 'POST'
	},
	// 新增价格
	addPriceMain: {
		url: url + 'price-main/add',
		description: '新增价格',
		type: 'POST'
	},
	// 更新价格
	updatePriceMain: {
		url: url + 'price-main/update',
		description: '更新价格',
		type: 'POST'
	},
	// 删除价格
	deletePriceMain: {
		url: url + 'price-main/delete',
		description: '删除价格',
		type: 'POST'
	},
	// 获取价格信息
	getPriceMainInfo: {
		url: url + 'price-main/info',
		description: '获取价格信息',
		type: 'POST'
	},
	// 价格方案明细管理
	getPriceSkuList: {
		url: url + 'price-sku/list',
		description: '价格方案明细管理',
		type: 'POST'
	},
	// 新增SKU价格
	addPricSku: {
		url: url + 'price-sku/add',
		description: '新增SKU价格',
		type: 'POST'
	},
	// 更新SKU价格
	updatePriceSku: {
		url: url + 'price-sku/update',
		description: '更新SKU价格',
		type: 'POST'
	},
	// 删除价格
	deletePriceSku: {
		url: url + 'price-sku/delete',
		description: '删除SKU价格',
		type: 'POST'
	},
	// 修改密码
	editPwd: {
		url: url + 'sys-user/updatePass',
		description: '修改密码',
		type: 'POST'
	},
	// 数据字典列表
	sysCodeSetList: {
		url: url + 'sys-code-set/listPage',
		description: '数据字典列表',
		type: 'POST'
	},
	// 新增数据字典
	addSysCodeSet: {
		url: url + 'sys-code-set/add',
		description: '新增数据字典',
		type: 'POST'
	},
	// 更新数据字典
	updateSysCodeSet: {
		url: url + 'sys-code-set/update',
		description: '更新数据字典',
		type: 'POST'
	},
	// 删除数据字典
	deleteSysCodeSet: {
		url: url + 'sys-code-set/delete',
		description: '删除数据字典',
		type: 'POST'
	},
	// 数据字典列表
	sysCodeSetChildList: {
		url: url + 'sys-code-set/childListPage',
		description: '数据字典列表',
		type: 'POST'
	},
	// 车辆信息列表
	carInfoList: {
		url: url + 'car-info/listPage',
		description: '车辆信息列表',
		type: 'POST'
	},
	// 新增车辆信息
	addCarInfo: {
		url: url + 'car-info/add',
		description: '新增车辆信息',
		type: 'POST'
	},
	// 更新车辆信息
	updateCarInfo: {
		url: url + 'car-info/update',
		description: '更新车辆信息',
		type: 'POST'
	},
	// 删除车辆信息
	deleteCarInfo: {
		url: url + 'car-info/delete',
		description: '删除车辆信息',
		type: 'POST'
	},
	// 组织新增
	groupAdd: {
		url: url + 'sys-company-group/add',
		description: '组织新增',
		type: 'POST'
	},
	// 组织修改
	groupUpdate: {
		url: url + 'sys-company-group/update',
		description: '组织修改',
		type: 'POST'
	},
	// 组织状态
	groupUpdateStatus: {
		url: url + 'sys-company-group/updateStatus',
		description: '组织状态',
		type: 'POST'
	},
	// 组织查看
	groupInfo: {
		url: url + 'sys-company-group/info',
		description: '组织查看',
		type: 'POST'
	},
	// 组织删除
	groupDelete: {
		url: url + 'sys-company-group/delete',
		description: '组织删除',
		type: 'POST'
	},
	// 组织用户查看
	groupUserListPage: {
		url: url + 'sys-user/listPage',
		description: '组织用户查看',
		type: 'POST'
	},
	// 组织用户新增
	groupAddUser: {
		url: url + 'sys-company-group/addUser',
		description: '组织用户新增',
		type: 'POST'
	},
	// 组织用户删除
	groupRemoveUser: {
		url: url + 'sys-company-group/removeUser',
		description: '组织用户删除',
		type: 'POST'
	},
	// 自动生成用户编码
	autoUserCode: {
		url: url + 'sys-user/autoUserCode',
		description: '自动生成用户编码',
		type: 'POST'
	},
	// 预付款账户列表
	prepaidAccountList: {
		url: url + 'prepaid-account/listPage',
		description: '预付款账户列表',
		type: 'POST'
	},
	// 预付款账户新增
	prepaidAccountAdd: {
		url: url + 'prepaid-account/add',
		description: '预付款账户新增',
		type: 'POST'
	},
	// 预付款账户更新
	prepaidAccountUpdate: {
		url: url + 'prepaid-account/update',
		description: '预付款账户更新',
		type: 'POST'
	},
	// 预付款账户删除
	prepaidAccountDelete: {
		url: url + 'prepaid-account/delete',
		description: '预付款账户删除',
		type: 'POST'
	},
	// 预付款充值
	prepaidAccountCharge: {
		url: url + 'preaccount-record/charge',
		description: '预付款充值',
		type: 'POST'
	},
	// 使用账户的客商列表
	preaccountAgentList: {
		url: url + 'preaccount-agent/listPage',
		description: '使用账户的客商列表',
		type: 'POST'
	},
	// 使用账户的客商新增
	preaccountAgentAdd: {
		url: url + 'preaccount-agent/add',
		description: '使用账户的客商新增',
		type: 'POST'
	},
	// 使用账户的客商删除
	preaccountAgentDelete: {
		url: url + 'preaccount-agent/delete',
		description: '使用账户的客商删除',
		type: 'POST'
	},
	// 客商信息列表
	agentList: {
		url: url + 'agent-info/list',
		description: '客商信息列表',
		type: 'POST'
	},
	// 客商信息新增
	agentAdd: {
		url: url + 'agent-info/add',
		description: '客商信息新增',
		type: 'POST'
	},
	// 客商信息批量修改
	agentBatchUpdate: {
		url: url + 'agent-info/batchUpdate',
		description: '客商信息批量修改',
		type: 'POST'
	},
	// 客商信息列表
	agentListPage: {
		url: url + 'agent-info/listPage',
		description: '客商信息列表',
		type: 'POST'
	},
	// 客商信息合并
	agentMergeAgent: {
		url: url + 'agent-info/mergeAgent',
		description: '客商信息合并',
		type: 'POST'
	},
	// 客商信息修改
	agentUpdate: {
		url: url + 'agent-info/update',
		description: '客商信息修改',
		type: 'POST'
	},
	// 客商组织部门
	agentSelectList: {
		url: url + 'sys-company-group/agentSelectList',
		description: '客商组织部门',
		type: 'POST'
	},
	// 客商信息删除
	agentDelete: {
		url: url + 'agent-info/delete',
		description: '客商信息删除',
		type: 'POST'
	},
	// 客商信息特渠
	agentCodeList: {
		url: url + 'sys-code-set/codeList',
		description: '客商信息特渠',
		type: 'POST'
	},
	// 右上角树结构
	changeTree: {
		url: url + 'sys-company-group/changeTree',
		description: '树结构',
		type: 'POST'
	},
	// 路线新增
	routeAdd: {
		url: url + 'route-info/add',
		description: '路线新增',
		type: 'POST'
	},
	// 路线新增客商
	routeAddAgent: {
		url: url + 'route-info/addAgent',
		description: '路线新增客商',
		type: 'POST'
	},
	// 删除客商关系
	routeDelAgent: {
		url: url + 'route-info/delAgent',
		description: '删除客商关系',
		type: 'POST'
	},
	// 路线删除
	routeDelete: {
		url: url + 'route-info/delete',
		description: '路线删除',
		type: 'POST'
	},
	// 路线查看
	routeInfo: {
		url: url + 'route-info/info',
		description: '路线查看',
		type: 'POST'
	},
	// 路线合并
	routeMergeAgent: {
		url: url + 'route-info/mergeAgent',
		description: '路线合并',
		type: 'POST'
	},
	// 路线修改
	routeUpdate: {
		url: url + 'route-info/update',
		description: '路线修改',
		type: 'POST'
	},
	// 路线启用/禁用
	routeUpdateStatus: {
		url: url + 'route-info/updateStatus',
		description: '路线启用/禁用',
		type: 'POST'
	},
	// 路线管理列表
	routeVlistPage: {
		url: url + 'route-info/vlistPage',
		description: '路线管理列表',
		type: 'POST'
	},
	// 路线组织部门
	busSelectList: {
		url: url + 'sys-company-group/busSelectList',
		description: '路线组织部门',
		type: 'POST'
	},
	// 路线管理列表
	routeAgent: {
		url: url + 'route-agent/vlistPage',
		description: '路线管理列表',
		type: 'POST'
	},
	// 配送周期列表
	routeDeliveryCycleList: {
		url: url + 'route-agent/vlist',
		description: '路线管理列表',
		type: 'POST'
	},
	// 配送周期编辑
	routeDeliveryCycleEdit: {
		url: url + 'route-info/setDeliveryCycle',
		description: '配送周期编辑',
		type: 'POST'
	},
	// 路线排序
	routeUpdateSort: {
		url: url + 'route-info/updateSort',
		description: '路线排序',
		type: 'POST'
	},
	// 上移，下移
	routeSort: {
		url: url + 'route-info/sort',
		description: '上移，下移',
		type: 'POST'
	},
	// 路线导出
	routeExport: {
		url: url + 'download/route-info/export',
		description: '路线导出',
		type: 'POST'
	},
	// 禁用/启用
	sysCodeUnlock: {
		url: url + 'sys-code-set/unlock',
		description: '数据字典禁用/启用',
		type: 'POST'
	},
	// 巡回计划列表
	roundPlanList: {
		url: url + 'round-plan/listPage',
		description: '巡回计划',
		type: 'POST'
	},
	// 巡回计划新增
	roundPlanAdd: {
		url: url + 'round-plan/add',
		description: '巡回计划',
		type: 'POST'
	},
	// 巡回计划更新
	roundPlanUpdate: {
		url: url + 'round-plan/update',
		description: '巡回计划',
		type: 'POST'
	},
	// 巡回计划删除
	roundPlanDelete: {
		url: url + 'round-plan/delete',
		description: '巡回计划',
		type: 'POST'
	},
	// 巡回计划信息
	roundPlanInfo: {
		url: url + 'round-plan/info',
		description: '巡回计划',
		type: 'POST'
	},
	// 巡回计划合并
	roundPlanMergeAgent: {
		url: url + 'round-plan/mergeAgent',
		description: '巡回计划',
		type: 'POST'
	},
	// 路线列表
	routeInfoList: {
		url: url + 'route-info/listPage',
		description: '路线列表',
		type: 'POST'
	},
	// 巡回计划新增客商
	roundPlanAddAgent: {
		url: url + 'round-plan/addAgent',
		description: '巡回计划',
		type: 'POST'
	},
	// 客商信息列表
	busAgentList: {
		url: url + 'agent-info/busAgentlist',
		description: '客商信息列表',
		type: 'POST'
	},
	// 客商信息删除客商关系
	deleteAgent: {
		url: url + 'round-plan/delAgent',
		description: '删除客商关系',
		type: 'POST'
	},
	// 客商信息排序
	roundPlanSort: {
		url: url + 'round-plan/sort',
		description: '客商信息排序',
		type: 'POST'
	},
	// 客商信息排序
	roundPlanList1: {
		url: url + 'round-plan/list',
		description: '客商信息排序',
		type: 'POST'
	},
	// 客商信息获取渠道细分
	getCodeDetailList: {
		url: url + 'sys-code-set/codeDetailList',
		description: '客商信息获取渠道细分',
		type: 'POST'
	},
	// 巡回计划导出
	roundPlanExport: {
		url: url + 'download/round-plan/export',
		description: '巡回计划导出',
		type: 'POST'
	},
	// 巡回计划客商排序
	roundPlanUpdateSort: {
		url: url + 'round-plan/updateSort',
		description: '巡回计划客商排序',
		type: 'POST'
	},
	// 客商信息标签
	getAgentTags: {
		url: url + 'agent-info/getAgentTags',
		description: '客商信息标签',
		type: 'POST'
	},
	// 客商信息导出
	agentInfoExport: {
		url: url + 'download/agent-info/export',
		description: '客商信息导出',
		type: 'POST'
	},
	// 车辆信息导出
	carInfoExport: {
		url: url + 'download/car-info/export',
		description: '车辆信息导出',
		type: 'POST'
	},
	// 预付款额度
	prepaidPage: {
		url: url + 'index/prepaidPage',
		description: '预付款额度',
		type: 'POST'
	},
	// 车辆里程列表
	kilometrageList: {
		url: url + 'car-kilometrage/listPage',
		description: '车辆里程列表',
		type: 'POST'
	},
	// 车辆里程删除
	kilometrageDelete: {
		url: url + 'car-kilometrage/delete',
		description: '车辆里程删除',
		type: 'POST'
	},
	// 车辆里程导出
	kilometrageExport: {
		url: url + 'download/car-kilometrage/export',
		description: '车辆里程导出',
		type: 'POST'
	},
	// 车辆检查
	checkList: {
		url: url + 'car-kilometrage/checkList',
		description: '车辆检查',
		type: 'POST'
	},
	// 车辆详细
	kilometrageInfo: {
		url: url + 'car-kilometrage/info',
		description: '车辆详细',
		type: 'POST'
	},
	// 车辆加油删除
	refuleDelete: {
		url: url + 'car-refule/delete',
		description: '车辆加油删除',
		type: 'POST'
	},
	// 车辆加油表
	refuleList: {
		url: url + 'car-refule/listPage',
		description: '车辆加油表',
		type: 'POST'
	},
	// 车辆加油导出
	refuleExport: {
		url: url + 'download/car-refule/export',
		description: '车辆加油导出',
		type: 'POST'
	},
	// 巡回计划启用禁用
	planUpdateStatus: {
		url: url + 'round-plan/updateStatus',
		description: '巡回计划启用禁用',
		type: 'POST'
	},
	// 签到拜访表
	visitListPage: {
		url: url + 'v-visit-info/vlistPage',
		description: '签到拜访表',
		type: 'POST'
	},
	// 签到拜访表导出
	visitExport: {
		url: url + 'download/v-visit-info/export',
		description: '签到拜访表导出',
		type: 'POST'
	},
	// 客商订单列表
	orderList: {
		url: url + 'order/listPage',
		description: '客商订单列表',
		type: 'POST'
	},
	// 客商订单查询
	orderInfo: {
		url: url + 'order/info',
		description: '客商订单查询',
		type: 'POST'
	},
	// 客商订单导出
	orderExport: {
		url: url + 'download/order/export',
		description: '客商订单导出',
		type: 'POST'
	},
	// 客商订单删除
	orderDelete: {
		url: url + 'order/delete',
		description: '客商订单删除',
		type: 'POST'
	},
	// 客商订单录入
	orderAdd: {
		url: url + 'order/add',
		description: '客商订单录入',
		type: 'POST'
	},
	// 客商订单sku
	orderSku: {
		url: url + 'order/skuList',
		description: '客商订单sku',
		type: 'POST'
	},
	// 收款单
	orderReceiptList: {
		url: url + 'order-receipt/listPage',
		description: '收款单',
		type: 'POST'
	},
	// 收款单导出
	orderReceiptExport: {
		url: url + 'download/order-receipt/export',
		description: '收款单导出',
		type: 'POST'
	},
	// 客商订单自定义表头
	getHeaderList: {
		url: url + 'order/getHeaderList',
		description: '客商订单自定义表头',
		type: 'POST'
	},
	// 客商订单自定义表头排序
	orderSort: {
		url: url + 'order/sort',
		description: '客商订单自定义表头',
		type: 'POST'
	},
	// 客商订单自定义表头保存
	saveHeader: {
		url: url + 'order/saveHeader',
		description: '客商订单自定义表头保存',
		type: 'POST'
	},
	// 装车单列表
	loadVehicleList: {
		url: url + 'load-vehicle/listPage',
		description: '装车单列表',
		type: 'POST'
	},
	// 装车单删除
	loadVehicleDelete: {
		url: url + 'load-vehicle/delete',
		description: '装车单删除',
		type: 'POST'
	},
	// 装车单详细
	loadVehicleInfo: {
		url: url + 'load-vehicle/info',
		description: '装车单详细',
		type: 'POST'
	},
	// 装车单导出
	loadVehicleExport: {
		url: url + 'download/load-vehicle/export',
		description: '装车单导出',
		type: 'POST'
	},
	// 生动化检查列表
	storeCheckList: {
		url: url + 'store-check/listPage',
		description: '装车单列表',
		type: 'POST'
	},
	// 生动化检查删除
	storeCheckDelete: {
		url: url + 'store-check/delete',
		description: '生动化检查删除',
		type: 'POST'
	},
	// 生动化检查详细
	storeCheckInfo: {
		url: url + 'store-check/info',
		description: '生动化检查详细',
		type: 'POST'
	},
	// 生动化检查导出
	storeCheckExport: {
		url: url + 'download/store-check/export',
		description: '生动化检查导出',
		type: 'POST'
	},
	// 其他出库列表
	outStoreList: {
		url: url + 'agent-out-store/listPage',
		description: '其他出库列表',
		type: 'POST'
	},
	// 其他出库删除
	outStoreDelete: {
		url: url + 'agent-out-store/delete',
		description: '其他出库删除',
		type: 'POST'
	},
	// 其他出库查询
	outStoreInfo: {
		url: url + 'agent-out-store/info',
		description: '其他出库查询',
		type: 'POST'
	},
	// 其他出库导出
	outStoreExport: {
		url: url + 'download/agent-out-store/export',
		description: '其他出库导出',
		type: 'POST'
	},
	// 巡回日报
	roundReportList: {
		url: url + 'report/round-report/listPage',
		description: '巡回日报',
		type: 'POST'
	},
	// 巡回日报导出
	roundReportExport: {
		url: url + 'report/round-report/export',
		description: '巡回日报导出',
		type: 'POST'
	},
	// 巡回日报查询
	roundReportInfo: {
		url: url + 'report/round-report/info',
		description: '巡回日报查询',
		type: 'POST'
	},
	// 销售台账
	saleStaticsList: {
		url: url + 'report/agent-sale-statics/listPage',
		description: '销售台账',
		type: 'POST'
	},
	// 销售台账导出
	saleStaticsExport: {
		url: url + 'report/agent-sale-statics/export',
		description: '销售台账导出',
		type: 'POST'
	},
	// 销售台账查询
	saleStaticsInfo: {
		url: url + 'report/agent-sale-statics/info',
		description: '巡回日报查询',
		type: 'POST'
	},
	// 库存导出
	agentExportStock: {
		url: url + 'download/store-check/exportStock',
		description: '库存导出',
		type: 'POST'
	},
	// 库存单个查询
	agentStockInfo: {
		url: url + 'store-check/infoStock',
		description: '库存单个查询',
		type: 'POST'
	},
	// 库存列表
	agentStockList: {
		url: url + 'store-check/listStockPage',
		description: '库存列表',
		type: 'POST'
	},
	// 库存删除
	agentDeleteStock: {
		url: url + 'store-check/deleteStock',
		description: '库存删除',
		type: 'POST'
	},
	// 客商台账列表
	agentSaleList: {
		url: url + 'report/agent-sale-statics-sku/listPage',
		description: '客商台账列表',
		type: 'POST'
	},
	// 巡回日报打印
	roundExportPdf: {
		url: url + 'report/round-report/exportPdf',
		description: '巡回日报打印',
		type: 'POST'
	},
	// 客商台账导出
	agentSaleExport: {
		url: url + 'report/agent-sale-statics-sku/export',
		description: '客商台账导出',
		type: 'POST'
	},
	// 客商NC同步
	agentsync: {
		url: url + 'agent-info/sync',
		description: '客商NC同步',
		type: 'POST'
	},
	// 店铺回单
	addVoucher: {
		url: url + 'order/addVoucher',
		description: '店铺回单',
		type: 'POST'
	},
	// 巡回计划撤回
	planCancel: {
		url: url + 'round-plan/cancel',
		description: '巡回计划撤回',
		type: 'POST'
	},
	// 客商台账查询条件数据
	agentSaleSearch: {
		url: url + 'report/agent-sale-statics-sku/search',
		description: '客商台账查询条件数据',
		type: 'POST'
	},
	// 客商订单同步
	orderSync: {
		url: url + 'order/sync',
		description: '客商订单同步',
		type: 'POST'
	},
	// 其他出库单同步
	agentOutStoreSync: {
		url: url + 'agent-out-store/sync',
		description: '其他出库单同步',
		type: 'POST'
	},
	// 巡回计划强制回车
	roundPlanBackCar: {
		url: url + 'round-plan/backCar',
		description: '巡回计划强制回车',
		type: 'POST'
	},
	// 路线导入
	routeImport: {
		url: url + 'route-info/import',
		description: '路线导入',
		type: 'POST'
	},
	// 出货仓
	wareList: {
		url: url + 'sys-group-store/list',
		description: '出货仓',
		type: 'POST'
	},
	// 出货仓
	setDefault: {
		url: url + 'sys-group-store/setDefault',
		description: '出货仓修改',
		type: 'POST'
	},
	// 批量店铺回单
	batchOrder: {
		url: url + 'order/batchUpdate',
		description: '批量店铺回单',
		type: 'POST'
	},
	// 出货仓
	storeList: {
		url: url + 'sys-group-sku-store/list',
		description: '出货仓',
		type: 'POST'
	},
	// 出货仓名选择
	storeSetDefault: {
		url: url + 'sys-group-sku-store/setDefault',
		description: '出货仓名选择',
		type: 'POST'
	},
	// 批量修改路线员
	batchUpdate: {
		url: url + 'route-info/batchUpdate',
		description: '批量修改路线员',
		type: 'POST'
	},
	// 客商sap信息
	agentInfoSap: {
		url: url + 'agent-info4-sap/info',
		description: '客商sap信息',
		type: 'POST'
	},
	// 是否默认选择(参数 gwId 主键ID selectFlag 强制【请选择】标签0：非强制，自动设置默认仓，1，不自动设置默认仓，必须手动选择)
	setSelectFlag: {
		url: url + 'sys-group-sku-store/setSelectFlag',
		description: '仓库默认设置',
		type: 'POST'
	},
	// 获取仓库
	getStores: {
		url: url + 'sys-group-store/list',
		description: '获取所有仓库',
		type: 'POST'
	},
	// 客商订单 导出仓库
	orderExportDetail: {
		url: url + 'download/order/detail',
		description: '客商订单 导出订单出货仓数据参数：orderilds',
		type: 'POST'
	},
	// 客商订单 导入仓库
	orderImport: {
		url: url + 'order/import',
		description: '客商订单 导入',
		type: 'POST'
	},
	// 其它仓库 导出
	storeExportDetail: {
		url: url + 'download/agent-out-store/detail',
		description: '其它仓库 导出 参数：orderilds',
		type: 'POST'
	},
	// 其它仓库 导入
	storImport: {
		url: url + 'agent-out-store/import',
		description: '其它仓库 导入',
		type: 'POST'
	},
	// 添加路线
	routeMapAdd: {
		url: url + 'route-map/add',
		description: '添加路线',
		type: 'POST'
	},
	// 添加区域
	routeMapAddArea: {
		url: url + 'route-map/addArea',
		description: '添加区域',
		type: 'POST'
	},
	// 路线列表
	routeMapListRoute: {
		url: url + 'route-map/listRoute',
		description: '路线列表',
		type: 'POST'
	},
	// 区域列表
	routeMapListArea: {
		url: url + 'route-map/listArea',
		description: '区域列表',
		type: 'POST'
	},
	// 导入
	routeMapImport: {
		url: url + 'route-map/import',
		description: '其它仓库',
		type: 'POST'
	},
	// 路线客商信息
	routeMapRouteAgents: {
		url: url + 'route-map/routeAgents',
		description: '路线客商信息',
		type: 'POST'
	},
	// 编辑区域
	routeMapUpdateArea: {
		url: url + 'route-map/updateArea',
		description: '编辑区域',
		type: 'POST'
	},
	// 客商信息
	routeMapAgentInfo: {
		url: url + 'route-map/agentInfo',
		description: '客商信息',
		type: 'POST'
	},
	// 移除客商
	routeMapDeleteAgent: {
		url: url + 'route-map/delAgent',
		description: '移除客商',
		type: 'POST'
	},
	// 客商路线变更
	routeMapChangeAgent: {
		url: url + 'route-map/changeAgent',
		description: '客商路线变更',
		type: 'POST'
	},
	// 圈选客商信息
	routeMapSelectAgent: {
		url: url + 'route-map/selectAgent',
		description: '圈选客商信息',
		type: 'POST'
	},
	// 渠道列表
	routeMapChannels: {
		url: url + 'route-map/channels',
		description: '渠道列表',
		type: 'GET'
	},
	// 店铺统计信息
	indexQueryAgent: {
		url: url + 'index/queryAgent',
		description: '店铺统计信息',
		type: 'POST'
	},
	// 路线以及客商信息
	routeMapInfo: {
		url: url + 'route-map/info',
		description: '路线以及客商信息',
		type: 'POST'
	},
	// 路线导入
	routeMapImport: {
		url: url + 'route-map/import',
		description: '路线导入',
		type: 'POST'
	},
	// 路线导出
	routeMapExport: {
		url: url + 'download/route-map/export',
		description: '路线以及客商信息',
		type: 'POST'
	},
	// 路线客商列表
	routeMapRAgentList: {
		url: url + 'route-map/rAgentlist',
		description: '路线客商列表',
		type: 'POST'
	},
	// 临时路线客商列表
	routeMapRAgentBuffList: {
		url: url + 'route-map/rAgentBufflist',
		description: '临时路线客商列表',
		type: 'POST'
	},
	// 路线地图移动排序
	routeMapSort: {
		url: url + 'route-map/sort',
		description: '路线地图移动排序',
		type: 'POST'
	},
	// 路线地图编辑排序
	routeMapUpdateSort: {
		url: url + 'route-map/updateSort',
		description: '路线地图编辑排序',
		type: 'POST'
	},
	// 路线地图采集坐标
	routeMapAddPoint: {
		url: url + 'route-map/addPoint',
		description: '路线地图采集坐标',
		type: 'POST'
	},
	// 路线地图检索
	routeMapQuery: {
		url: url + 'route-map/query',
		description: '路线地图检索',
		type: 'POST'
	},
	// 路线地图发布
	routeMapPubRoute: {
		url: url + 'route-map/pubRoute',
		description: '路线地图发布',
		type: 'POST'
	},
	// 路线列表
	routeMapInfoList: {
		url: url + 'route-map/listPage',
		description: '路线列表',
		type: 'POST'
	},
	// 路线列表
	routeMapDeleteRouteMap: {
		url: url + 'route-map/delRouteBuff',
		description: '路线列表',
		type: 'POST'
	},
	// 路线地图删除区域
	routeMapDeleteArea: {
		url: url + 'route-map/delArea',
		description: '路线地图删除区域',
		type: 'POST'
	},
	// 路线地图颜色变更
	routeMapAddColor: {
		url: url + 'route-map/addColor',
		description: '路线地图颜色变更',
		type: 'POST'
	},
	// 路线地图变更路线列表选择
	routeMapChangeListPage: {
		url: url + 'route-map/changelistPage',
		description: '路线地图变更路线列表选择',
		type: 'POST'
	},
	// 路线地图重置路线
	routeMapReset: {
		url: url + 'route-map/reset',
		description: '路线地图重置路线',
		type: 'POST'
	},
	// 无路线点击
	routeMapNotRouteAgents: {
		url: url + 'route-map/nonRouteAgents',
		description: '无路线点击',
		type: 'POST'
	},
	// 客商信息-批量调整属性-批量设置自贩价格
	agentInfoBatchUpdatePrice: {
		url: url + 'agent-info/batchUpdatePrice',
		description: '无路线点击',
		type: 'POST'
	},
	// 路线客商渠道统计
	routeMapListChannel: {
		url: url + 'route-map/listChannel',
		description: '路线客商渠道统计',
		type: 'POST'
	},
	// 路线客商配送周期调整
	routeMapListChannelSum: {
		url: url + 'route-map/listChannelSum',
		description: '路线客商配送周期调整',
		type: 'POST'
	},
	// 路线客商配送周期调整
	routeMapDeliveryCycleEdit: {
		url: url + 'route-map/setDeliveryCycle',
		description: '配送周期编辑',
		type: 'POST'
	},
	// 设置路线类型
	setRouteType: {
		url: url + 'route-map/setRouteType',
		description: '设置路线类型',
		type: 'POST'
	},
	// 追加路线客商（路线ID数组：routeIds,客商ID:agentId）
	addRouteAgentBuff: {
		url: url + 'route-map/addRouteAgentBuff',
		description: '追加路线客商（路线ID数组：routeIds,客商ID:agentId）',
		type: 'POST'
	},
	// 编辑中路线及配送周期列表（参数：agentId）
	listRAgents: {
		url: url + 'route-map/listRAgents',
		description: '编辑中路线及配送周期列表（参数：agentId）',
		type: 'POST'
	},
	// 调序
	routeMapUpdateSort: {
		url: url + 'route-map/updateSort',
		description: '设置路线类型',
		type: 'POST'
	},
	// 配置文件重置
	downloadRelod: {
		url: url + 'download/reload',
		description: '设置路线类型',
		type: 'POST'
	},
	// 配置文件重置
	sysCodeSetReload: {
		url: url + 'sys-code-set/reload',
		description: '设置路线类型',
		type: 'POST'
	},
	// 路线目标管理
	routeGoalList: {
		url: url + 'route-goal/listPage',
		description: '路线目标管理',
		type: 'POST'
	},
	// 路线目标管理
	routeGoalAdd: {
		url: url + 'route-goal/add',
		description: '路线目标管理',
		type: 'POST'
	},
	// 路线目标管理
	routeGoalExport: {
		url: url + 'download/route-goal/export',
		description: '路线目标管理',
		type: 'POST'
	},
	// 路线目标管理
	routeGoalInfo: {
		url: url + 'route-goal/info',
		description: '路线目标管理',
		type: 'POST'
	},
	// 路线目标管理
	routeGoalImport: {
		url: url + 'route-goal/import',
		description: '路线目标管理',
		type: 'POST'
	},
}

export default api
